export default {
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setEvaluatesList(state, evaluatesList) {
    state.evaluatesList.push(...(evaluatesList || []))
  },
  resetEvaluatesList(state) {
    state.evaluatesList = []
  },
  setUserServiceList(state, servicesList) {
    state.servicesList.push(...(servicesList || []))
  },
  setUserExperience(state, list) {
    state.experienceList.push(...(list || []))
  },
  resetUserExperience(state) {
    state.experienceList = []
  }
}
